import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';

//import custom rest client
import { CREATE } from 'admin-on-rest';
import restClient from '../restClient';

const buttonStyle = { display: 'block', marginTop: '20px' };

class ToggleAdButton extends Component {
   	constructor(props){
	    super(props);
    	this.state = { 
				disabled: props.record.alreadysubscribed === 1 ? true : false,
				label: props.record.alreadysubscribed === 1 ? 'Reeds toegevoegd' : 'Advertentie toevoegen',				
				};
  	}
  
    handleClick = () => {
        const { push, record, showNotification } = this.props;
       
	    const createRecord = { cloudhintsdomains_id: record.id };
        
		restClient(CREATE, 'member/ads', {data: createRecord} )
            .then(() => {
                showNotification('ads.ad_created');
                 this.setState({
				  disabled: true
				})
				
				push('/member/ads/create#refresh');
            })
            .catch((e) => {
                console.error(e);
                showNotification('cloudhints.error_try_again', 'warning')
            });
    }

    render() {
        return <RaisedButton primary style={buttonStyle} disabled={ this.state.disabled } label={ this.state.label } onClick={this.handleClick} />;
    }
}

ToggleAdButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification: showNotificationAction,
    push: pushAction,
})(ToggleAdButton);


// WEBPACK FOOTER //
// ./src/admin_ads/ToggleAdButton.js